import React, { Suspense } from 'react';
import { Route, Routes } from "react-router-dom";
import { Spinner } from "reactstrap";

import NonAuthLayout from "../layouts/NonAuthLayout";
import VerticalLayout from "../layouts/index";

import { authProtectedRoutes, publicRoutes } from "./AllRoutes";
import { AuthProtected } from './AuthProtected';
import ChunkErrorBoundary from "@/components/Common/ChunkErrorBoundary";

import { useGetAccessUsersQuery } from "../api/Endpoints/Core/Security/Users";
import { getCurrentUser, hasAccess } from "../helpers/session_helper";

const PageLoader = () => (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <Spinner color="primary" />
    </div>
);

const Index = () => {
    const shouldFetch = getCurrentUser();
    const { data, isLoading } = useGetAccessUsersQuery({}, { skip: !shouldFetch });

    const accessRights = data?.returnData?.map(({ permissionTypeId, allowRead, allowWrite, allowDelete }) => ({
        permissionTypeId,
        allowRead,
        allowWrite,
        allowDelete,
    }));

    // Don't build the protected table until rights have landed —
    // otherwise every gated route is filtered out and "*" fires.
    const protectedRoutes = (shouldFetch && isLoading)
        ? []
        : authProtectedRoutes.filter(route => hasAccess(route.permissionTypeId, accessRights));

    if (shouldFetch && isLoading) return <PageLoader />;

    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    <ChunkErrorBoundary>
                                        <Suspense fallback={<PageLoader />}>
                                            {route.component}
                                        </Suspense>
                                    </ChunkErrorBoundary>
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {protectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>
                                        <ChunkErrorBoundary>
                                            <Suspense fallback={<PageLoader />}>
                                                {route.component}
                                            </Suspense>
                                        </ChunkErrorBoundary>
                                    </VerticalLayout>
                                </AuthProtected>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
};

export default Index;